import React, { Component } from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';

class ASRDeleteRegexStringDialog extends Component {
  onRenderCaption() {
    return 'Delete regular expression';
  }

  onRenderBody() {
    return (
      <span className='asr-dialog-delete-message'>
        {'Are you sure you want to delete this regular expression?'}
      </span>
    );
  }

  onRenderFooter() {
    return (
      <span className='asr-dialog-footer'>
        <button className='asr-dialog-footer-cancel-button' onClick={this.props.onClose}>
          No
        </button>
        <button className='asr-dialog-footer-save-button' onClick={this.props.onConfirm}>
          Yes
        </button>
      </span>
    );
  }

  render() {
    return (
      <Dialog show={this.props.show} width={30} height={30} >
        <DialogHeader caption={this.onRenderCaption()} closeButton onClose={this.props.onClose} />
        <DialogBody>
          {this.onRenderBody()}
        </DialogBody>
        <DialogFooter>
          {this.onRenderFooter()}
        </DialogFooter>
      </Dialog>
    );
  }
}

export default ASRDeleteRegexStringDialog;


// WEBPACK FOOTER //
// ./src/content/enterprise/asr/components/ASRDeleteRegexStringDialog.js